// src/FlashContext.js
import React from 'react';

const FlashContext = React.createContext();

export default FlashContext;